/* a11y.js — accessibility fixes requiring JavaScript
   Section 1: Flickity carousel focus management (SC 2.4.3, 4.1.2, 2.4.7) */
(function () {
  'use strict';
  var THRESHOLD = 0.5; // a cell must be >=50% inside the viewport to be reachable
  var FOCUSABLE = 'a[href],button,input,select,textarea,[tabindex]';

  function suppress(cell) {
    Array.prototype.forEach.call(cell.querySelectorAll(FOCUSABLE), function (el) {
      if (!el.hasAttribute('data-a11y-ti')) {
        el.setAttribute('data-a11y-ti', el.getAttribute('tabindex') === null ? '' : el.getAttribute('tabindex'));
      }
      el.setAttribute('tabindex', '-1');
    });
  }

  function restore(cell) {
    Array.prototype.forEach.call(cell.querySelectorAll('[data-a11y-ti]'), function (el) {
      var prev = el.getAttribute('data-a11y-ti');
      if (prev === '') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', prev); }
      el.removeAttribute('data-a11y-ti');
    });
  }

  function updateCarousel(carousel) {
    var viewport = carousel.querySelector('.flickity-viewport') || carousel;
    var vRect = viewport.getBoundingClientRect();

    Array.prototype.forEach.call(carousel.querySelectorAll('.carousel-cell'), function (cell) {
      var r = cell.getBoundingClientRect();
      var overlap = Math.max(0, Math.min(r.right, vRect.right) - Math.max(r.left, vRect.left));
      var visible = r.width > 0 && (overlap / r.width) >= THRESHOLD;

      if (visible) {
        cell.removeAttribute('inert');
        cell.removeAttribute('aria-hidden');
        restore(cell);
      } else {
        cell.setAttribute('aria-hidden', 'true');
        if ('inert' in HTMLElement.prototype) { cell.inert = true; } else { suppress(cell); }
      }
    });
  }

  function bind(carousel) {
    if (carousel.getAttribute('data-a11y-bound')) return;
    carousel.setAttribute('data-a11y-bound', '1');
    updateCarousel(carousel);
    if (window.Flickity && window.Flickity.data) {
      var f = window.Flickity.data(carousel);
      if (f && f.on) {
        f.on('select', function () { updateCarousel(carousel); });
        f.on('settle', function () { updateCarousel(carousel); });
        f.on('resize', function () { updateCarousel(carousel); });
      }
    }
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.flickity-enabled'), bind);
  }

  // Flickity may initialise after DOMContentLoaded; poll briefly, then stop.
  var tries = 0;
  var timer = setInterval(function () { if (++tries > 20) clearInterval(timer); scan(); }, 250);
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.flickity-enabled'), updateCarousel);
  });
})();

/* Section 2: keep the closed off-canvas menu out of the tab order
   (SC 2.4.3 Focus Order, 2.4.7 Focus Visible)
   #off-canvas-menu is hidden at left:-100% but stays visibility:visible,
   so its 9 links remain tabbable on desktop — focus lands ~1585px
   off-screen with no visible indicator. CSS can't fix this reliably
   because .visible-xs{visibility:visible!important} overrides it. */
(function () {
  'use strict';
  function sync() {
    var oc = document.getElementById('off-canvas-menu');
    if (!oc) return;
    var open = oc.classList.contains('is-active');
    var toggle = document.getElementById('offcanvas-new-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if ('inert' in HTMLElement.prototype) {
      oc.inert = !open;
    } else {
      Array.prototype.forEach.call(
        oc.querySelectorAll('a[href],button,input,select,textarea'),
        function (el) {
          if (open) { el.removeAttribute('tabindex'); }
          else { el.setAttribute('tabindex', '-1'); }
        });
    }
    if (open) { oc.removeAttribute('aria-hidden'); }
    else { oc.setAttribute('aria-hidden', 'true'); }
  }
  function init() {
    var oc = document.getElementById('off-canvas-menu');
    if (!oc) return;
    sync();
    new MutationObserver(sync).observe(oc, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.addEventListener('load', init);
})();

/* Section 3: announce cart changes to assistive technology
   (SC 4.1.3 Status Messages, AA)
   The theme has zero live regions: adding to cart mutates the DOM with no
   page load, no focus move and no announcement, so a screen reader user
   gets no confirmation at all. Watches the Vue cart object rather than
   patching the minified handlers. */
(function () {
  'use strict';
  var REGION_ID = 'cart-status';

  function region() {
    var el = document.getElementById(REGION_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = REGION_ID;
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      document.body.insertBefore(el, document.body.firstChild);
    }
    return el;
  }

  function announce(msg) {
    var el = region();
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 100);
  }

  function money(cents, cart) {
    if (typeof cents !== 'number') return '';
    var sym = (cart && cart.currency === 'USD') ? '$' : '';
    return sym + (cents / 100).toFixed(2);
  }

  function init() {
    var app = document.getElementById('app');
    var vue = app && app.__vue__;
    if (!vue || !vue.cart) return false;

    region(); // create it up front — a live region must pre-exist its content

    var prevCount = vue.cart.item_count;
    var prevItems = (vue.cart.items || []).map(function (i) { return i.key || i.id; }).join(',');

    vue.$watch(function () { return this.cart; }, function (cart) {
      if (!cart) return;
      var count = cart.item_count;
      var items = (cart.items || []).map(function (i) { return i.key || i.id; }).join(',');
      if (count === prevCount && items === prevItems) return;

      var msg;
      if (count > prevCount) {
        msg = 'Added to cart. ' + count + (count === 1 ? ' item' : ' items') +
              ', subtotal ' + money(cart.total_price, cart) + '.';
      } else if (count < prevCount) {
        msg = count === 0 ? 'Item removed. Your cart is now empty.'
              : 'Item removed. ' + count + (count === 1 ? ' item' : ' items') +
                ', subtotal ' + money(cart.total_price, cart) + '.';
      } else {
        msg = 'Cart updated. ' + count + (count === 1 ? ' item' : ' items') +
              ', subtotal ' + money(cart.total_price, cart) + '.';
      }
      prevCount = count; prevItems = items;
      announce(msg);
    }, { deep: true });

    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (init() || ++tries > 25) clearInterval(timer);
  }, 250);
})();

/* Section 4: announce toastr notifications (SC 4.1.3, 3.3.1)
   toastr injects #toast-container into <body> at the same moment as the
   message. Its toasts carry aria-live="polite", but a live region created
   simultaneously with its content is not announced — AT only monitors
   regions it has already registered. Pre-create the container so toastr
   reuses it, and mirror warnings/errors into an assertive region. */
(function () {
  'use strict';

  function ensureContainer() {
    var c = document.getElementById('toast-container');
    if (!c) {
      c = document.createElement('div');
      c.id = 'toast-container';
      c.className = 'toast-top-right';
      c.setAttribute('role', 'status');
      c.setAttribute('aria-live', 'polite');
      c.setAttribute('aria-atomic', 'false');
      document.body.appendChild(c);
    } else if (!c.getAttribute('aria-live')) {
      c.setAttribute('role', 'status');
      c.setAttribute('aria-live', 'polite');
      c.setAttribute('aria-atomic', 'false');
    }
    return c;
  }

  function alertRegion() {
    var el = document.getElementById('toast-alert-status');
    if (!el) {
      el = document.createElement('div');
      el.id = 'toast-alert-status';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');
      el.setAttribute('aria-atomic', 'true');
      document.body.insertBefore(el, document.body.firstChild);
    }
    return el;
  }

  function clean(t) {
    return (t || '').replace(/^\s*×\s*/, '').replace(/\s+/g, ' ').trim();
  }

  function init() {
    var container = ensureContainer();
    var region = alertRegion();

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1 || !n.classList || !n.classList.contains('toast')) return;
          // Warnings and errors are urgent — mirror them into an assertive
          // region so they interrupt rather than wait for a pause.
          if (n.classList.contains('toast-warning') || n.classList.contains('toast-error')) {
            var msg = clean(n.textContent);
            if (msg) {
              region.textContent = '';
              setTimeout(function () { region.textContent = msg; }, 100);
            }
          }
        });
      });
    }).observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* Section 5: quantity selector — names and change announcements
   (SC 4.1.2 Name Role Value, 4.1.3 Status Messages)
   The Vue qty-component renders <input type="button" value="-|+"> around an
   unlabelled <input type="number">. The buttons announce as "minus"/"plus"
   with no context, and because focus stays on the button while the value
   changes on a sibling, the new quantity is never announced. */
(function () {
  'use strict';
  var uid = 0;

  function region() {
    var el = document.getElementById('qty-status');
    if (!el) {
      el = document.createElement('div');
      el.id = 'qty-status';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      document.body.insertBefore(el, document.body.firstChild);
    }
    return el;
  }

  function announce(msg) {
    var el = region();
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 100);
  }

  function enhance(wrap) {
    if (wrap.getAttribute('data-a11y-qty')) return;
    wrap.setAttribute('data-a11y-qty', '1');

    var field = wrap.querySelector('.qty-value');
    var minus = wrap.querySelector('.minus');
    var plus  = wrap.querySelector('.plus');
    if (!field) return;

    // Label the number field.
    if (!field.id) { field.id = 'qty-field-' + (++uid); }
    if (!field.getAttribute('aria-label')) {
      field.setAttribute('aria-label', 'Quantity');
    }

    if (minus) minus.setAttribute('aria-label', 'Decrease quantity');
    if (plus)  plus.setAttribute('aria-label', 'Increase quantity');

    // Announce the new value after the component updates it.
    var last = field.value;
    function report() {
      setTimeout(function () {
        if (field.value !== last) {
          last = field.value;
          announce('Quantity ' + field.value);
        }
      }, 250);
    }
    if (minus) minus.addEventListener('click', report);
    if (plus)  plus.addEventListener('click', report);
    field.addEventListener('change', function () { last = field.value; });
  }

  function scan() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.quantity, .qty-wrapper'), enhance);
  }

  function init() {
    region();
    scan();
    // The cart drawer and cart page render qty-components dynamically.
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.addEventListener('load', init);
})();